module.exports = __webpack_public_path__ + "img/pic5_bg_hover.a71cd59.webp";